import React from 'react';
import { Link } from 'react-router-dom';
import { animated, useTransition } from '@react-spring/web';

import { marked } from 'marked';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAnimatedRouteState } from '@wildidea/components/AnimatedRoutes/AnimatedRoutes';
import { Card } from '@wildidea/components/Card/Card';
import { useThemeAnimations } from '@wildidea/components/Theme/Theme';

import { TERMS_OF_SERVICE } from './terms-of-service.js';

import * as css from './TermsOfServiceRoute.module.css';

import 'github-markdown-css';

const html = marked(TERMS_OF_SERVICE);

// In frame mode, include a document header, because the frame header will be removed
// Strip links so users can't navigate within the iframe
const frameHtml = marked(`# Rescue Ally Terms of Service
  ${TERMS_OF_SERVICE}`)
  .toString()
  .replace(/<a[^>]*>(.*?)<\/a>/g, '$1');

const TermsOfServiceRoute: React.FC<{}> = () => {
  const { phase, onTransitionEnd } = useAnimatedRouteState();
  const active = phase === 'enter' || phase === 'active';
  const { fromBelow } = useThemeAnimations('Common');
  const contentTransition = useTransition(active, { ...fromBelow, onRest: onTransitionEnd });

  return contentTransition((style, active) =>
    active ? (
      <animated.div style={style} className={css.layout}>
        <Card
          color="transparent"
          className={css.contentCard}
          header={
            <div className={[css.header, 'h1-margin'].join(' ')}>
              <Link to="/" aria-label="Back">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Link>
              <h1>Rescue Ally Terms of Service</h1>
            </div>
          }
        >
          <article dangerouslySetInnerHTML={{ __html: html.toString() }} />
        </Card>
      </animated.div>
    ) : null
  );
};

/** Standalone frame-friendly version: no animation, no navigation chrome, no links in content. */
export const TermsOfServiceFrameRoute: React.FC<{}> = () => (
  <div className={css.layout}>
    <Card color="transparent" className={css.contentCard}>
      <article dangerouslySetInnerHTML={{ __html: frameHtml.toString() }} />
    </Card>
  </div>
);

export default TermsOfServiceRoute;
